const cityToAreaMap = {
    'Helsinki': 'Uusimaa',
    'Tampere': 'Pirkanmaa',
    'Turku': 'Southwest Finland',
    'Oulu': 'North Ostrobothnia',
    'Jyväskylä': 'Central Finland',
    'Lahti': 'Päijät-Häme',
    'Pori': 'Satakunta',
    'Kuopio': 'North Savo',
    'Vaasa': 'Ostrobothnia',
    'Joensuu': 'North Karelia',
    'Lappeenranta': 'South Karelia',
    'Kotka': 'Kymenlaakso',
    'Rovaniemi': 'Lapland',
    'Kouvola': 'Kymenlaakso',
    'Hämeenlinna': 'Kanta-Häme',
    'Seinäjoki': 'South Ostrobothnia',
    'Hyvinkää': 'Uusimaa',
    'Porvoo': 'Uusimaa',
    'Mikkeli': 'South Savo',
    'Kokkola': 'Central Ostrobothnia',
    'Rauma': 'Satakunta',
    'Lohja': 'Uusimaa',
    'Kajaani': 'Kainuu',
    'Salo': 'Southwest Finland',
    'Imatra': 'South Karelia',
    'Riihimäki': 'Kanta-Häme',
    'Kemi': 'Lapland',
    'Savonlinna': 'South Savo',
    'Forssa': 'Kanta-Häme',
    'Jakobstad': 'Ostrobothnia',
    'Pietarsaari': 'Ostrobothnia',
}

const regions = [
    {
        label: "lapland",
        description: "Lapland",
        keywords: null,
        imageURL: null,
        popularity: 1
    },
    {
        label: "northern-ostrobothnia",
        description: "Northern Ostrobothnia",
        keywords: null,
        imageURL: null,
        popularity: 1
    },
    {
        label: "kainuu",
        description: "Kainuu",
        keywords: null,
        imageURL: null,
        popularity: 1
    },
    {
        label: "north-ostrobothnia",
        description: "North Ostrobothnia",
        keywords: null,
        imageURL: null,
        popularity: 1
    },
    {
        label: "north-karelia",
        description: "North Karelia",
        keywords: null,
        imageURL: null,
        popularity: 1
    },
    {
        label: "north-savo",
        description: "North Savo",
        keywords: null,
        imageURL: null,
        popularity: 1
    },
    {
        label: "south-save",
        description: "South Savo",
        keywords: null,
        imageURL: null,
        popularity: 1
    },
    {
        label: "south-karelia",
        description: "South Karelia",
        keywords: null,
        imageURL: null,
        popularity: 1
    },
    {
        label: "central-finland",
        description: "Central Finland",
        keywords: null,
        imageURL: null,
        popularity: 1
    },
    {
        label: "south-ostrobothnia",
        description: "South Ostrobothnia",
        keywords: null,
        imageURL: null,
        popularity: 1
    },
    {
        label: "ostrobothnia",
        description: "Ostrobothnia",
        keywords: null,
        imageURL: null,
        popularity: 1
    },
    {
        label: "central-ostrobothnia",
        description: "Central Ostrobothnia",
        keywords: null,
        imageURL: null,
        popularity: 1
    },
    {
        label: "pirkanmaa",
        description: "Pirkanmaa",
        keywords: null,
        imageURL: null,
        popularity: 1
    },
    {
        label: "satakunta",
        description: "Satakunta",
        keywords: null,
        imageURL: null,
        popularity: 1
    },
    {
        label: "paijat-hame",
        description: "Päijät-Häme",
        keywords: null,
        imageURL: null,
        popularity: 1
    },
    {
        label: "kanta-hame",
        description: "Kanta-Häme",
        keywords: null,
        imageURL: null,
        popularity: 1
    },
    {
        label: "kymenlaakso",
        description: "Kymenlaakso",
        keywords: null,
        imageURL: null,
        popularity: 1
    },
    {
        label: "uusimaa",
        description: "Uusimaa",
        keywords: null,
        imageURL: null,
        popularity: 1
    },
    {
        label: "southwest-finland",
        description: "Southwest Finland",
        keywords: null,
        imageURL: null,
        popularity: 1
    },
    {
        label: "aland",
        description: "Åland",
        keywords: null,
        imageURL: null,
        popularity: 1
    }
]


function cityToLocation(city) {
    if ( ! city ) return { city: city, area: '', country: 'Finland' };
    const key = city.substring(0,1).toUpperCase() + city.substring(1).toLowerCase();
    return cityToAreaMap[key]
        ? { city: key, area: cityToAreaMap[key], country: 'Finland' }
        : { city: city, area: '', country: 'Finland' };
}

function labelToRegion(label){
    let item = regions.find((item) => item.label == label);
    return item ? item : null;
}

export { cityToLocation, labelToRegion }
